import request from '@/utils/request'

/**
 * 分页查询表单
 * @param {Object} data 查询参数
 * @returns {Promise}
 */
export function searchHealthForms(data) {
  return request({
    url: '/health-forms/search',
    method: 'post',
    data
  })
}

/**
 * 查询所有表单（不分页）
 * @returns {Promise}
 */
export function getAllHealthForms() {
  return request({
    url: '/health-forms/list',
    method: 'get'
  })
}

/**
 * 获取当前用户可填报的健康表单
 * @returns {Promise}
 */
export function getAvailableForms() {
  return request({
    url: '/health-forms/available',
    method: 'get'
  })
}

/**
 * 获取健康表单详情
 * @param {number} id 健康表单ID
 * @returns {Promise}
 */
export function getHealthFormDetail(id) {
  return request({
    url: `/api/health-forms/${id}`,
    method: 'get'
  })
}

/**
 * 根据ID查询表单详情
 * @param {Number} id 表单ID
 * @returns {Promise}
 */
export function getHealthFormById(id) {
  return request({
    url: `/health-forms/${id}`,
    method: 'get'
  })
}

/**
 * 新增表单
 * @param {Object} data 表单数据
 * @returns {Promise}
 */
export function createHealthForm(data) {
  return request({
    url: '/health-forms',
    method: 'post',
    data
  })
}

/**
 * 更新表单
 * @param {Number} id 表单ID
 * @param {Object} data 表单数据
 * @returns {Promise}
 */
export function updateHealthForm(id, data) {
  return request({
    url: `/health-forms/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除表单
 * @param {Number} id 表单ID
 * @returns {Promise}
 */
export function deleteHealthForm(id) {
  return request({
    url: `/health-forms/${id}`,
    method: 'delete'
  })
}

/**
 * 启用/禁用表单
 * @param {Number} id 表单ID
 * @param {Number} status 状态 1启用 2禁用
 * @returns {Promise}
 */
export function updateHealthFormStatus(id, status) {
  return request({
    url: `/health-forms/${id}/status`,
    method: 'post',
    data: { status }
  })
} 